import { toDate } from 'date-fns';
import {
  GET_REQUEST,
  GET_REQUESTS,
  GET_EMPLOYEE_REQUESTS,
  CREATE_REQUEST,
  UPDATE_REQUEST,
  DELETE_REQUEST,
} from '../actionTypes';
import moment from 'moment';
import { DB_DATE_FORMAT } from '../constants';
import { getAxiosInstance } from '../utils/axios-api';
import { getAccessToken } from '../utils/customMethods';
import { notify } from '../utils/notifications/notifications';

export const getRequest = requestId => async dispatch => {
  dispatch({
    type: GET_REQUEST,
    payload: undefined,
  });
};

export const getRequests = userId => async dispatch => {
  try {
    let response = await getAxiosInstance().get(
      `/timeOffRequest/${userId}?access_token=${getAccessToken()}`
    );

    if (response.status === 200) {
      dispatch({
        type: GET_REQUESTS,
        payload: response.data,
      });
      return true;
    }
    if (response.status !== 200) {
      console.log('SOME ERROR OCCURRED', response);
      return false;
    }
  } catch (ex) {
    console.log('ERROR', ex);
    return false;
  }
};

export const getRequestsByDate = obj => async dispatch => {
  try {
    let response = await getAxiosInstance().get(
      `/timeOffRequest?access_token=${getAccessToken()}&fromDate=${moment(obj.fromDate).format(DB_DATE_FORMAT) }&toDate=${moment(obj.toDate).format(DB_DATE_FORMAT)}`
    );

    if (response.status === 200) {
      dispatch({
        type: GET_REQUESTS,
        payload: response.data,
      });
      return true;
    }
    if (response.status !== 200) {
      console.log('SOME ERROR OCCURRED', response);
      return false;
    }
  } catch (ex) {
    console.log('ERROR', ex);
    return false;
  }
};
export const getEmployeeRequests = currentUserId => async dispatch => {
  try {
    let response = await getAxiosInstance().get(
      `/timeOffRequest/${currentUserId}?access_token=${getAccessToken()}`
    );
    if (response.status === 200 && response.data) {
      let usersRequests = response.data.filter(request => {
        return request.userId === currentUserId;
      });

      dispatch({
        type: GET_EMPLOYEE_REQUESTS,
        payload: usersRequests,
      });
      return true;
    } else {
      console.log('some error occurred while getting employee request');
      return false;
    }
  } catch (error) {
    console.log('ERROR', error);
    return false;
  }
};

export const createRequest = reqObj => async dispatch => {
  try {
    let response = await getAxiosInstance().post(
      `/timeOffRequest?access_token=${getAccessToken()}`,
      reqObj
    );
    if (response.status === 201) {
      dispatch({
        type: CREATE_REQUEST,
        payload: response.data,
      });
      notify('success', 'Request Created!');
      return true;
    }
    if (response.status === 200) {
      console.log('CREATE REQUEST ERROR', response);
      notify(
        'error',
        'You do not have enough available time accrued. Please update you request or contact your manager.'
      );
      return true;
    }
    return false;
  } catch (ex) {
    console.log('ERROR', ex);
    notify('error', 'An error occurred. Please try again or contact your administrator');
    return false;
  }
};

export const updateRequest = (reqId, actionUserId, reqObj) => async dispatch => {
  try {
    let response = await getAxiosInstance().put(
      `/timeOffRequest/${reqId}/${actionUserId}?access_token=${getAccessToken()}`,
      reqObj
    );
    if (response.status === 200) {
      notify('success', 'The request has been updated');

      return true;
    }
    return false;
  } catch (error) {}
};

export const deleteRequest = (reqId, actionUserId) => async dispatch => {
  try {
    let response = await getAxiosInstance().delete(
      `/timeOffRequest/${reqId}/${actionUserId}?access_token=${getAccessToken()}`
    );

    if (response.status === 200) {
      notify('success', 'Request deleted successfully');
      dispatch({
        type: DELETE_REQUEST,
        payload: undefined,
      });
      return true;
    }

    notify(
      'error',
      'There was a problem processing your request. Please try again or contact you administrator.'
    );
    return false;
  } catch (error) {
    console.log('ERROR WITH DELETE REQUEST', error);
  }
};
